import type { DossierDTO } from '@/features/api/extranet/dto/Dossier/Synthese'
import type { ModuleFinancementDTO } from '@/features/api/extranet/dto/Dossier/Synthese/FinancementDTO'
import type { Statut } from '@/features/domaine/types/opco/Dossier'
import { formatNumber } from '@/features/shared/tools'
import { dateFormatter } from '@/features/shared/tools/date'
import { computed } from 'vue'

export function useDossierTTDetailHelper(model: DossierDTO) {
  const itemStatut = computed<Statut>(() => {
    if (model.statut) {
      return model.statut as Statut
    }
    return 'Transmis'
  })

  const financementDemandeRecap = computed(() => {
    let total = 0
    model.financements?.forEach((elem) => {
      if (elem?.typeMontantDemande === 'Monetaire') total += elem.montantDemande!
    })
    return formatNumber(total, { decimal: 2, separateur: true })
  })

  const financementAccordeRecap = computed(() => {
    let total = 0
    model.financements?.forEach((elem) => {
      elem.financementDetails?.forEach((elem) => {
        total += elem?.montantEngage ?? 0
      })
    })
    return formatNumber(total, { decimal: 2, separateur: true })
  })

  const financementRegleRecap = computed(() => {
    let total = 0
    model.financements?.forEach((elem) => {
      elem.financementDetails?.forEach((elem) => {
        total += elem?.montantRegle ?? 0
      })
    })
    return formatNumber(total, { decimal: 2, separateur: true })
  })

  const financementSoldeRecap = computed(() => {
    let total = 0
    model.financements?.forEach((elem) => {
      elem.financementDetails?.forEach((elem) => {
        total += elem?.montantSolde ?? 0
      })
    })
    return formatNumber(total, { decimal: 2, separateur: true })
  })

  const detailModulesList = computed<Array<Array<ModuleFinancementDTO>>>(() => {
    const list = [] as Array<Array<ModuleFinancementDTO>>

    model.modules?.forEach((elem) => {
      const financement = <ModuleFinancementDTO[]>[]
      model.financements?.forEach((item) => {
        if (item.idModule === elem.idModule) {
          const newItem = { ...item } as any
          newItem.dateDebut = dateFormatter(elem.dateDebut)
          newItem.dateFin = dateFormatter(elem.dateFin)
          newItem.organisme = elem.etablissementPrestataire.denomination
          newItem.intitule = elem.intitule
          financement.push(newItem)
        }
      })
      if (financement.length) {
        list.push(financement)
      }
    })
    return list
  })

  return {
    itemStatut,
    financementDemandeRecap,
    financementAccordeRecap,
    financementRegleRecap,
    financementSoldeRecap,
    detailModulesList,
  }
}
